import Customer from "@api/types/customer";
import React, { FC } from "react";

import Spacer from "@components/Spacer";

const SupportContainer: FC<{ customer: Customer }> = ({ customer }) => {
  return (
    <>
      <h1>Support</h1>
      <p>
        <strong>Logging In: </strong> If you have not logged onto the site since April 12, 2022 - you will
        need to reset your password to log in. Your user name is the same, but click on the “Forgot your
        password?” link and follow the instructions to reset your password.
      </p>
      <p>
        <strong>Enrollment Codes / Activating Licenses: </strong> If you have an enrollment code (an
        enrollment card or supplied from the support team), you will need to log in to your account and use
        the “Activate License” link at the top of the page. Then enter your enrollment code and choose the
        course. Your course will then appear in the 'My Online Courses” area on the site when you are logged
        in.
      </p>
      <p>
        <strong>Train the Trainer In-Person Courses: </strong> You can find courses on the “Calendar” link at
        the top of the page. Note that you do need to be logged in or create an account to enroll in a course
        on the site. Click on the “Buy Now” and follow the checkout process to purchase the course. You will
        receive an email reminder with a link to add the event to your personal calendar. The course will also
        appear in the 'My Courses” area on the site when you are logged in.
      </p>
      <Spacer size={"sm"} />
      <h1>Help Center</h1>
      {customer.guest ? (
        <p>
          Please{" "}
          <a href={"/login"} style={{ fontWeight: "bold", textDecoration: "underline" }}>
            log in
          </a>{" "}
          to create a new help request or access your open help requests.
        </p>
      ) : (
        <p>
          If there are additional questions, feel free submit a request in the{" "}
          <a href={"/help-center"}>help center</a>.
        </p>
      )}
      <style jsx>{`
        h1 {
          font-size: 30px;
          font-weight: 500;
        }

        a {
          color: rgb(0, 102, 204);
        }
      `}</style>
    </>
  );
};

export default SupportContainer;
